export enum ProductPageSectionType {
  PROCEDURE = 'procedure',
  TEMPLATE = 'template',
}

export interface ProductPageSectionParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  procedureInstanceId: string;
  title: string;
  description?: string;
  position: number;
  type: ProductPageSectionType;
}

export interface ProductPageSectionData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  procedureInstanceId: string;
  title: string;
  description?: string;
  position: number;
  type: ProductPageSectionType;
}

export type ProductPageSectionCreateData = Omit<ProductPageSectionData, 'id' | 'createdAt' | 'updatedAt'>;
